import React, { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from '../../configurations/axiosInstance/AxiosInstance';
import { LoadingContext } from '../../composants/loadingContext';
import Loader from '../../composants/loader/Loader';
import LexicalViewer from '../editor/LexicalViewer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faUsers, faHeart, faRocket } from '@fortawesome/free-solid-svg-icons';
import './Infos.css';

const Infos = () => {
  const { loading, setLoading } = useContext(LoadingContext);
  const nav = useNavigate();
  const [slide, setSlide] = useState(null);
  const { id } = useParams();
  const getSlideById = () => {
    setLoading(true);
    axiosInstance().get(
      "public/sliders/" + id
    ).then((result) => {
      if (result.data != null) {
        setSlide(result.data)
      }
      setLoading(false);
    }).catch((result) => {
      setLoading(false);
    });
  }

  useEffect(
    () => {
      getSlideById();
      document.title = 'Infos - YouthFP';
    }, []
  );

  return (
    <>
      {loading && <Loader />}


      <div
        className="relative text-white py-24 overflow-hidden"
        style={slide?.photo ? {
          backgroundImage: `url(${slide.photo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        } : {
          background: 'linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #3b82f6 100%)'
        }}
      >
        {/* Overlay dynamique */}
        <div className={`absolute inset-0 ${slide?.photo ? 'bg-black/50' : 'bg-white/10'} backdrop-blur-[2px]`}>
          <div className="absolute top-0 left-0 w-full h-full opacity-30">
            <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 shadow-2xl">
              <img src={slide?.photo} alt="" />
            </div>
            <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">
              {slide?.title || "À Propos de Nous"}
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              {slide?.message || "Notre mission, notre vision, nos valeurs"}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Content Section */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
            {slide?.content ? (
              <div className="p-8 md:p-12">
                <div className="mb-8">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4 flex items-center gap-3">
                    <div className="w-1 h-8 bg-gradient-to-b from-purple-500 to-pink-500 rounded-full"></div>
                    {slide?.title}
                  </h2>
                </div>
                <div className="prose prose-lg max-w-none">
                  <LexicalViewer
                    content={slide?.content}
                    showCard={false}
                  />
                </div>
              </div>
            ) : !loading && (
              <div className="text-center py-20 px-4">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mb-6">
                  <FontAwesomeIcon icon={faInfoCircle} className="text-5xl text-purple-500" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  Contenu en préparation
                </h3>
                <p className="text-gray-600 max-w-md mx-auto">
                  Nous mettons à jour notre page À Propos. Revenez bientôt pour en savoir plus sur notre organisation.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Infos;